import { useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const BILLING_FALLBACK = '/billing';

/**
 * Hook for navigating within billing pages.
 * All modals are nested child routes under each tab,
 * so simple relative navigate() calls are all that's needed.
 */
export function useBillingNavigation() {
  const navigate = useNavigate();
  const location = useLocation();

  // Close modal — go back if there's in-app history, otherwise fall back to /billing
  const goBack = useCallback(() => {
    if (location.key !== "default") {
      navigate(-1);
    } else {
      navigate(BILLING_FALLBACK, { replace: true });
    }
  }, [navigate, location.key]);

  return {
    navigate,
    location,
    goBack,
  };
}
